import { __module as hasClass } from '../../../../../_virtual/hasClass.js';

var hasRequiredHasClass;

function requireHasClass () {
	if (hasRequiredHasClass) return hasClass.exports;
	hasRequiredHasClass = 1;
	(function (module, exports) {

		exports.__esModule = true;
		exports.default = hasClass;

		function hasClass(element, className) {
		  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
		}

		module.exports = exports["default"]; 
	} (hasClass, hasClass.exports));
	return hasClass.exports;
}

export { requireHasClass as __require };
